export enum RecurrenceRuleFrequency {
  Daily = 0,
  Weekly = 1
}

export interface RecurrenceRule {
  frequency: RecurrenceRuleFrequency;
  interval: number;
  recurringDays: RecurrenceRuleRecurringDay[];
}

export enum RecurrenceRuleRecurringDay {
  Monday = 0,
  Tuesday = 1,
  Wednesday = 2,
  Thursday = 3,
  Friday = 4,
  Saturday = 5,
  Sunday = 6
}
